import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { CREDIT_CARD_PROCESSORS } from '../../constants';

const CVV_REGEX = new RegExp(/^([0-9]+)$/);
const ROUTING_NUMBER_REGEX = new RegExp(/^([0-9]{9})$/);

export function creditCardNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const formGroup = control.parent as FormGroup;
    return formGroup.get('processor')?.value ? null : { invalid: true };
  };
}

export function creditCardCvvDigitsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = control.value.toString().match(CVV_REGEX);
    return isValid ? null : { invalid: true };
  };
}

export function creditCardCvvLengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const formGroup = control.parent as FormGroup;
    const processorValue = formGroup.get('processor')?.value;
    if (!processorValue) return null;
    const cvvLength = CREDIT_CARD_PROCESSORS.find((p) => p.value === processorValue)!.cvvLength;
    return control.value!.toString().length === cvvLength ? null : { invalid: true };
  };
}

// PLPWP-2195 - Fixed CC expiration date error
export function creditCardExpirationValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const formGroup = control.parent as FormGroup;
    const expirationYearValue = formGroup.get('expirationYear')?.value;

    if (!expirationYearValue) return null;

    const expirationDate = moment(`${expirationYearValue}-${pad(control.value, 2)}-01`);
    const isInFuture = expirationDate.startOf('day').isSameOrAfter(moment().startOf('day'));

    return isInFuture ? null : { invalid: true };
  };
}

function pad(num: string, size: number): string {
  num = num.toString();
  while (num.length < size) {
    num = '0' + num;
  }

  return num;
}

export function bankAccountRoutingNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = control.value.toString().match(ROUTING_NUMBER_REGEX);
    // TODO Add an additional validation based on checksums
    return isValid ? null : { invalid: true };
  };
}
